/**
 * 
 * Multi Select Box
 * 
 */

import React from 'react';
import {MultiSelect} from 'primereact/multiselect';
import { DROPDOWN_CONFIG } from '../../Config';

class MultiSelectBox extends React.Component {

    render() {
        const { name, label, value, placeholder, metaData, onInputChange, noLabel, disabled } = this.props;

        // Ensure value is always an array for MultiSelect
        let arrayValue = [];
        if (Array.isArray(value)) {
            arrayValue = value;
        } else if (typeof value === 'string' && value) {
            arrayValue = value.split(',').map(v => v.trim()).filter(v => v);
        }

        return (<div className="p-col-12">
            {!noLabel ? <label className="label">
                {label}
                {/* <span className="requiredColor">*</span> */}
            </label> : null}
            <div className="mt1">
                    <MultiSelect
                        disabled={disabled}
                        name={name}
                        placeholder={placeholder}
                        value={arrayValue}
                        options={metaData && metaData[label] && Array.isArray(metaData[label]) && metaData[label] || []}
                        onChange={onInputChange}
                        filter={true}
                        className="p-col-12 p-md-8 p-lg-8"
                        {...DROPDOWN_CONFIG} />
            </div>
        </div>)
    }
}


export default MultiSelectBox;